import React from 'react';
import { useParams } from 'react-router-dom';
import BaseLayout from '@/components/layouts/BaseLayout';
import ArticleHeader from '@/components/Article/ArticleHeader';
import ArticleContent from '@/components/Article/ArticleContent';
import FeedbackForm from '@/components/feedback/FeedbackForm';
import { useArticle } from '@/hooks/useArticle';

const ArticlePage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const { article, isLoading, error } = useArticle(slug);

  if (isLoading) {
    return (
      <BaseLayout>
        <div className="container mx-auto px-4 py-8">
          <div className="animate-pulse">
            <div className="h-8 bg-gray-200 rounded w-3/4 mb-4"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2 mb-8"></div>
            <div className="h-64 bg-gray-200 rounded mb-8"></div>
            <div className="space-y-4">
              <div className="h-4 bg-gray-200 rounded w-full"></div>
              <div className="h-4 bg-gray-200 rounded w-5/6"></div>
              <div className="h-4 bg-gray-200 rounded w-4/6"></div>
            </div>
          </div>
        </div>
      </BaseLayout>
    );
  }

  if (error || !article) {
    return (
      <BaseLayout>
        <div className="container mx-auto px-4 py-8">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-900 mb-4">Article Not Found</h1>
            <p className="text-gray-600">The article you're looking for doesn't exist or has been removed.</p>
          </div>
        </div>
      </BaseLayout>
    );
  }

  return (
    <BaseLayout>
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <ArticleHeader article={article} />
          <ArticleContent article={article} />
          
          {/* Add the feedback form at the bottom of the article */}
          <div className="mt-12 border-t border-gray-200 pt-8">
            <FeedbackForm articleSlug={slug || ''} />
          </div>
        </div>
      </div>
    </BaseLayout>
  );
};

export default ArticlePage; 